import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=7104d4a4&scoped=true&"
import script from "./WaitingList.vue?vue&type=script&lang=js&"
export * from "./WaitingList.vue?vue&type=script&lang=js&"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=7104d4a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104d4a4",
  null
  
)

export default component.exports